<template>
   <header>
      <div class="row ">
        <div class="col-xs-5 col-sm-3 col-md-2">
          <img id="logo" src="@/assets/logo.svg" alt="">
        </div>
        <div class="col-xs-7 col-sm-9 col-md-10 end-xs" id="navbar">
          <!-- <router-link to="/"> Home </router-link>
          <a href="#works">Works </a>
          <a href="#client">Client </a>
          <a href="#services">Services </a>
          <a href="#contact">Contact </a> -->
          <a class="button xs-hide" href="#contact">Hire us</a>
          <div class="hamburger" @click="togleMenu" ><img src="@/assets/hamburger.svg" alt=""></div>
          
        </div>
      </div>
      <transition name="fade"><menuList v-if="showMenu" :onClose="togleMenu" /></transition>
    </header>
</template>
<script>
import {mapActions,mapState} from 'vuex';
import menuList from '@/components/menuList'
export default {
  components:{menuList},
  data() {
    return {
      
    }
  },
  methods: {
    ...mapActions(['togleMenu']),
  },
  computed: {
    ...mapState(['showMenu'])
  }
}
</script>
<style lang="scss" scoped>
#logo{
  max-width: 130px;
}
#navbar {
    align-items: center;
    align-content: center;
    display: flex;
    .hamburger{
      margin-left:50px;
    }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>